<template>
  <div class="main-panel main-panel__center testpage">
    <div v-if="currentPageIndex == 0">
      <!-- <div>
        <div>Device: {{ deviceInfo.deviceType }}</div>
        <div>OS: {{ deviceInfo.operatingSystem }}</div>
        <div>Wallets: {{ deviceInfo.cryptoWallets.join(', ') }}</div>
        <div>isMobile: {{ isMobile }}</div>
      </div> -->
      <AuInput
        v-model="textValue"
        placeholder="Текст"
      />

      <AuInput
        v-model="numberValue"
        placeholder="Числа от 5 до 100"
        :decimal="2"
        :indent="2"
        :max="10000"
        :min="500"
        type="Number"
      />

      <AuInput
        v-model="dateValue"
        placeholder="Даты"
        enable-time-picker
        type="Date"
        :format="formatView"
      />

      <AuSelect
        :value="selectValue"
        :options="selectOptions"
        placeholder="Селект"
        @input="(value) => (selectValue = value)"
      />
    </div>
    <div v-else-if="currentPageIndex == 1">
      <div class="card">
        MarkDown
        <div class="mt-4">
          <AuMarkdown
            v-model="textWs"
            :required="true"
            :show-view="true"
            :placeholder="
              $t('projects.form.firstStep.projectDescEngPlaceholder')
            "
            :show-preview="true"
          />
        </div>
      </div>
      <div class="card">
        WYSIWYG
        <div class="mt-4">
          <AuWysiwyg
            v-model="textWs"
            :required="true"
            :placeholder="
              $t('projects.form.firstStep.projectDescEngPlaceholder')
            "
            :show-preview="true"
          />
        </div>
      </div>
    </div>
    <div v-else-if="currentPageIndex == 2">
      <div class="card">
        <div class="mb-2">
          default, disable false
        </div>
        <div class="d-flex">
          <AuSwitchButton
            class="dist"
            width="66px"
            border-radius="8"
          >
            {{ $t("All") }}
          </AuSwitchButton>
          <AuSwitchButton
            class="dist"
            width="66px"
            :font-size="14"
          >
            {{ $t("dashboard.rates.buttons.all") }}
          </AuSwitchButton>
          <AuButton
            class="dist"
            center
            @click="getMore"
          >
            {{ $t("Download more") }}
          </AuButton>
        </div>

        <div class="mt-2 mb-2">
          primary, disable false
        </div>
        <div class="d-flex">
          <AuSwitchButton
            type="primary"
            class="dist"
            width="66px"
            border-radius="8"
          >
            {{ $t("All") }}
          </AuSwitchButton>
          <AuSwitchButton
            type="primary"
            class="dist"
            @click="getMore"
          >
            {{ $t("dashboard.rates.buttons.all") }}
          </AuSwitchButton>
          <AuButton
            type="primary"
            class="dist"
            center
            @click="getMore"
          >
            {{ $t("Download more") }}
          </AuButton>
        </div>

        <hr>
        <div class="mt-2 mb-2">
          disable true
        </div>
        <div class="d-flex">
          <AuSwitchButton
            disabled
            class="dist"
            width="66px"
            border-radius="8"
          >
            {{ $t("All") }}
          </AuSwitchButton>
          <AuSwitchButton
            disabled="true"
            class="dist"
            width="66px"
            :font-size="14"
          >
            {{ $t("dashboard.rates.buttons.all") }}
          </AuSwitchButton>
          <AuButton
            disabled
            class="dist"
            center
            @click="getMore"
          >
            {{ $t("Download more") }}
          </AuButton>
        </div>
      </div>
    </div>
    <div v-else-if="currentPageIndex == 3">
      <AuBreadcrumb parent-name="Домой" />

      <AuTabView padding-slide="0">
        <AuTabPanel title="Панель 1">
          1
        </AuTabPanel>

        <AuTabPanel title="Панель 2">
          2
        </AuTabPanel>

        <AuTabPanel title="Панель 3">
          3
        </AuTabPanel>
      </AuTabView>

      <AuPagination :total-items="totalItems" />
    </div>
    <div v-else-if="currentPageIndex == 4">
      <div class="card">
        <span> Toasts </span>
        <div class="d-flex gap-4 mt-4">
          <AuButton @click="$toast.info('Info', { timeout: 100000 })">
            Info
          </AuButton>
          <AuButton @click="$toast.error('Error', { timeout: 100000 })">
            Error
          </AuButton>
          <AuButton @click="$toast.warning('Warning', { timeout: 100000 })">
            Warning
          </AuButton>
          <AuButton @click="$toast.success('Success', { timeout: 100000 })">
            Success
          </AuButton>
          <AuButton
            @click="
              $toast.info('DontShowInMenu', {
                timeout: 100000,
                showInMenu: false
              })
            "
          >
            DontShowInMenu
          </AuButton>
        </div>
      </div>

      <ProgressLoader
        mode="indeterminate"
        color="#5AC396"
        size="150px"
      />

      <ProgressBarWrapper
        :procent="25"
        green
      >
        <template #top-left>
          <span> 1 </span>
        </template>

        <template #top-right>
          <span> 2 </span>
        </template>

        <template #bottom-left>
          <span> 3 </span>
        </template>

        <template #bottom-right>
          <span> 4 </span>
        </template>
      </ProgressBarWrapper>

      <WizardWrap
        :texts="texts"
        :stage="0"
      />

      <WizardWrap
        :texts="texts"
        :stage="1"
      />

      <div class="block-bc">
        <div class="block-i">
          <BriefcaseHorizontal />
        </div>
        <div class="block-i" />
        <div class="block-i" />
      </div>
    </div>
    <div v-else-if="currentPageIndex == 5">
      <div class="card">
        <span class="mb-4">Таблица</span>
        <AuTable
          :columns="tableColumns"
          :items="tableItems"
        />
      </div>

      <div class="card mt-4">
        <span class="mb-4">Аккордион</span>
        <AuAccordion
          v-for="(owner, index) in tableItems"
          :key="index"
        >
          <template #title>
            <span>{{ owner.property1 }}</span>
          </template>
          <template #content>
            <div
              v-for="(column, cindex) in tableColumns"
              :key="cindex"
              class="row"
            >
              <div class="d-flex justify-content-between">
                <span>
                  {{ column.name }}
                </span>
                <span>
                  {{ owner[column.property] }}
                </span>
              </div>
            </div>
          </template>
        </AuAccordion>
      </div>

      <div class="card mt-4">
        <span class="mb-4">Список</span>
        <AuList :items="listItems" />
      </div>
    </div>
    <div v-else-if="currentPageIndex == 6">
      <Form>
        <template #title>
          Заголовок
        </template>
        <template #subtitle>
          Подзаголовок
        </template>

        <template #header-right>
          <AuButton type="primary">
            Кнопка
          </AuButton>
        </template>

        <div>Контент</div>
      </Form>

      <Form footer-flex="flex-start">
        <template #header-left>
          Левый хедер
        </template>

        <template #header-right>
          Правый хедер (или кнопка)
        </template>

        <div>Контент</div>

        <template #footer>
          <AuButton type="primary">
            Кнопка
          </AuButton>
        </template>
      </Form>

      <Form>
        <template #header>
          Хедер
        </template>

        <div>Контент</div>

        <template #footer>
          <AuButton type="primary">
            Кнопка 1
          </AuButton>

          <AuButton type="primary">
            Кнопка 2
          </AuButton>
        </template>
      </Form>

      <div class="card test">
        Градиент тестирования
      </div>

      <div class="d-flex gap-3">
        <CapitalCardLoader
          v-for="item in [1, 2, 3, 4]"
          :key="item"
          :is-investment="true"
          height="338px"
        />
      </div>
    </div>
    <div v-else-if="currentPageIndex == 7">
      <AuTable
        class="briefcase-table briefcase-table-hiddable"
        :columns="columnsTable"
        :items="itemsTable"
      >
        <template #result="{ value }">
          <AuDecimalStatic
            v-bind="value"
            :show-addition="false"
          />
        </template>
      </AuTable>
    </div>
    <div v-else-if="currentPageIndex == 8">
      <span class="mb-4">
        <a
          target="_blank"
          href="https://sakai.primevue.org/"
        > Sakai Theme </a>
      </span>
    </div>
  </div>
</template>

<script>
import AuTabPanel from "@/components/extended/tabs/AuTabPanel";
import AuTabView from "@/components/extended/tabs/AuTabView";
import BriefcaseHorizontal from "@/panels/components/BriefcaseHorizontal.vue";
import CapitalCardLoader from "@/components/capital/CapitalCardLoader";
import ProgressBarWrapper from "@/components/progressBar/ProgressBarWrapper.vue";
import ProgressLoader from "@/loaders/progress-bar";
import WizardWrap from "@/components/wizard/WizardWrap.vue";

import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import { useDeviceDetector } from "@/composables/useDeviceDetector";

export default {
  name: "TestPage",

  components: {
    BriefcaseHorizontal,
    ProgressLoader,
    CapitalCardLoader,
    AuTabPanel,
    AuTabView,
    WizardWrap,
    ProgressBarWrapper
  },

  data() {
    return {
      deviceInfo: {
        deviceType: "",
        operatingSystem: "",
        cryptoWallets: []
      },
      page: 3,
      totalItems: 100,
      textWs: "",
      loading: false,
      numberValue: "",
      selectValue: null,
      selectOptions: [
        { display: 1, value: 1 },
        { display: 2, value: 2 }
      ],
      dateValue: null,
      textValue: null,
      texts: [
        {
          label: {
            text: "Заголовок"
          },
          link: {
            text: "",
            link: "/user"
          },
          button: {
            text: "Кнопка",
            link: "/user"
          },
          verification: false
        },
        {
          label: {
            text: "Заголовок"
          },
          link: {
            text: "",
            link: "/"
          },
          button: {
            text: "Кнопка",
            link: "/user"
          },
          verification: true
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      currentPageIndex: "testPage/currentPageIndex",
      isTestRole: "profile/isTestRole"
    }),

    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },

    tableColumns() {
      return [
        { name: "Столбец 1", property: "property1" },
        { name: "Столбец 2", property: "property2" },
        { name: "Столбец 3", property: "property3", align: "end" }
      ];
    },

    tableItems() {
      return [
        {
          property1: 11,
          property2: 12,
          property3: 13
        },
        {
          property1: 21,
          property2: 22,
          property3: 23
        }
      ];
    },

    listItems() {
      return [
        [
          { title: "Свойство 1", value: 123 },
          { title: "Свойство 2", value: "123" },
          {
            title: "Цветное свойство",
            value: "ВАУ",
            valueStyle: { color: "#30BC89" }
          }
        ],
        [
          { title: "Свойство 3", value: "Yes", checkbox: true },
          { title: "Свойство 4", value: "No", checkbox: false }
        ]
      ];
    },

    typeTitle() {
      return this.$t("transactions.titleType.spending");
    },

    columnsTable() {
      return [
        { name: "value", align: "start" },
        { name: "decimal", property: "decimal" },
        { name: "indent", property: "indent" },
        { name: "smart indent", property: "smartIndent" },
        { name: "trim zeros", property: "trimZeros" },
        { name: "correct result", property: "correct" },
        {
          name: "result",
          align: "center",
          slot: "result",
          property: "result",
          decimal: true
        }
      ];
    },

    itemsTable() {
      const values = [
        {
          value: "25",
          decimal: 4,
          indent: 6,
          smartIndent: false,
          trimZeros: false,
          correct: "0.002500"
        },
        {
          value: "25",
          decimal: 4,
          indent: 6,
          smartIndent: false,
          trimZeros: true,
          correct: "0.0025"
        },
        {
          value: "25",
          decimal: 4,
          indent: 6,
          smartIndent: true,
          trimZeros: false,
          correct: "0.00250000"
        },
        {
          value: "25",
          decimal: 4,
          indent: 6,
          smartIndent: true,
          trimZeros: true,
          correct: "0.0025"
        },
        {
          value: "25",
          decimal: 4,
          indent: 2,
          smartIndent: false,
          trimZeros: false,
          correct: "0.00"
        },
        {
          value: "25",
          decimal: 4,
          indent: 2,
          smartIndent: false,
          trimZeros: true,
          correct: "0"
        },
        {
          value: "25",
          decimal: 4,
          indent: 2,
          smartIndent: true,
          trimZeros: false,
          correct: "0.0025"
        },
        {
          value: "25",
          decimal: 4,
          indent: 2,
          smartIndent: true,
          trimZeros: true,
          correct: "0.0025"
        },
        {
          value: "2500",
          decimal: 2,
          indent: 2,
          smartIndent: false,
          trimZeros: false,
          correct: "25.00"
        },
        {
          value: "2500",
          decimal: 2,
          indent: 2,
          smartIndent: false,
          trimZeros: true,
          correct: "25"
        },
        {
          value: "2500",
          decimal: 2,
          indent: 2,
          smartIndent: true,
          trimZeros: false,
          correct: "25.0000"
        },
        {
          value: "2500",
          decimal: 2,
          indent: 2,
          smartIndent: true,
          trimZeros: true,
          correct: "25"
        },
        {
          value: "25001500",
          decimal: 8,
          indent: 5,
          smartIndent: false,
          trimZeros: false,
          correct: "0.25001"
        }
      ];

      return _.map(values, (value) => {
        return {
          ...value,
          result: value
        };
      });
    }
  },

  mounted() {
    this.detectDeviceInfo();
    if (!this.isTestRole) {
      this.$router.push("/");
    }
  },

  methods: {
    getMore() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },

    async detectDeviceInfo() {
      const { detectAll } = useDeviceDetector();
      const info = await detectAll();
      this.deviceInfo = info;
    },

    formatView(date) {
      return moment(date).locale("ru").format("L HH:mm");
    }
  }
};
</script>

<style>
.testpage .tabs_info {
  background: none;
  border: 2px var(--card-color) solid;
}
</style>

<style scoped lang="scss">
.main-panel {
  display: flex;

  &__center {
    width: 100%;
    height: calc(100% - 65px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-x: auto;
    overflow-y: auto;
    padding: 20px 25px 15px 25px;
    background-color: var(--main-color);
  }

  > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}

.dist {
  margin-right: 4px;
}

.block-bc {
  display: flex;
  gap: 10px;
}

.block-i {
  flex: 1;
  border-radius: 15px;
  background-color: #d1d1d17c;
  max-width: calc(33.33% - 10px);
  box-sizing: border-box;
}

.test {
  padding: 20px;
  background: var(--tester-color);
}
</style>
